export default __webpack_public_path__ + "static/media/menu-banner-01.6b63f5f9.jpg";